import { useEffect, useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getCookie, MD5 } from '@/lib/utils/dom.manipulation';

const clearsaleAppKey = process.env.CLEARSALE_APP_KEY;

const useClearSaleFingerprint = () => {
  const [token, setToken] = useState<string>('');
  const visitorId = useMemo(() => uuidv4(), []);

  const clearSaleFingerPrintResult = useMemo(() => {
    try {
      return MD5(decodeURIComponent(token?.replace(/"/gi, '')));
    } catch {
      return '';
    }
  }, [token]);

  useEffect(() => {
    const script = document.createElement('script');

    script.innerHTML = `
        (function (a, b, c, d, e, f, g) {
          a['CsdpObject'] = e;
          a[e] = a[e] || function () {
            (a[e].q = a[e].q || []).push(arguments)
          },
          a[e].l = 1 * Date.now();
          f = b.createElement(c), g = b.getElementsByTagName(c)[0];
          f.async = 1; f.src = d;
          g.parentNode.insertBefore(f, g)
        })(window, document, 'script', '//device.clearsale.com.br/p/fp.js', 'csdp');
        csdp('app', '${clearsaleAppKey}');
        csdp('sessionid', '${visitorId}');
      `;

    clearsaleAppKey && document.body.appendChild(script);

    const checkToken = () => {
      const oauthToken = getCookie('JSESSIONID');
      if (oauthToken) {
        setToken(oauthToken);
      }
    };

    const interval = setInterval(checkToken, 1000);

    return () => {
      clearsaleAppKey && document.body.removeChild(script);
      clearInterval(interval);
    };
  }, [visitorId]);

  return clearSaleFingerPrintResult;
};

export default useClearSaleFingerprint;
